import { UseMutateFunction, useMutation } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { AddBoxFirst } from 'services/addBox'
import { RootState } from 'store/redux'
import { resetImage } from 'store/redux/image'
import { reset, toggleMoneyPool } from 'store/redux/moneyPoolBox'
import posthog from 'posthog-js'
import useFinishFlow, { FLOWS } from 'utilities/navigation/flow'

export default function useSetAddFirstBox(
    CustomImageMutate: UseMutateFunction<
        any,
        unknown,
        {
            file: File
            id: number
        },
        unknown
    >,
    statege: number | undefined
) {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    // Stage 0 is «ثبت سوابق مدیر»: an existing fund, whether the manager said
    // so up front (the «انتقال صندوق به همیان» entries) or only in the modal.
    const isTransfer = statege !== 1
    const transferOrigin = store?.isTransfer ? 'start' : 'last_modal'
    const imageStore = useSelector((state: RootState) => state.imageReducer)
    // The fund exists from here on, so the forms that described it are
    // spent: back from wherever this lands must not reopen them.
    const finishFlow = useFinishFlow(FLOWS.createFund)
    const dispatch = useDispatch()
    const { mutate, isLoading } = useMutation({
        mutationFn: (payload: IAddBoxFirstPayload) => {
            return AddBoxFirst(payload)
        },
        onSuccess: (res) => {
            dispatch(
                toggleMoneyPool({
                    moneyPool: res.results.id,
                    poolShip: res.results.poolship.id,
                })
            )
            if (store?.image_id !== undefined) {
                if (statege === 1) {
                    dispatch(reset())
                    dispatch(resetImage())
                    posthog.capture('fund_created', {
                        creation_path: 'system_image',
                        fund_id: (res as any)?.results?.id,
                        goal: store?.goal || undefined,
                        is_transfer: false,
                    })
                    finishFlow('/funds')
                    toast.success('صندوق با موفقیت ساخته شد')
                } else {
                    // The fund exists now, but `fund_created` waits for the
                    // records; this is where a transfer stops being a draft.
                    posthog.capture('fund_transfer_base_created', {
                        creation_path: 'system_image',
                        fund_id: res?.results?.id,
                        transfer_origin: transferOrigin,
                    })
                    toast.success(
                        'صندوق شما با اطلاعات اولیه ساخته شد . اکنون سوابق مدیر را وارد کنید'
                    )

                    finishFlow('/add-box/manager-records', {
                        id: res?.results?.id,
                        poolShip: res?.results?.poolship?.id,
                    })
                }
            } else if (imageStore?.image) {
                const formData = new FormData()
                formData.append('custom_avatar', imageStore?.image)
                CustomImageMutate({
                    file: imageStore?.image,
                    id: res?.results?.id,
                })
            }
        },
        onError: () => {
            posthog.capture('fund_create_failed', {
                creation_path: 'system_image',
                goal: store?.goal || undefined,
                is_transfer: isTransfer,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate, isLoading }
}
